var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.407,
    height: 15.406,
    viewBox: "0 0 15.407 15.406",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "git",
    transform: "translate(-0.001 -0.935)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M15.117,8.024,8.39,1.3a.992.992,0,0,0-1.4,0l-1.4,1.4L7.362,4.466a1.178,1.178,0,0,1,1.492,1.5l1.707,1.708a1.18,1.18,0,1,1-.707.666L8.262,6.749V10.94a1.193,1.193,0,0,1,.312.223,1.181,1.181,0,1,1-1.283-.258V6.676A1.166,1.166,0,0,1,6.9,6.418,1.18,1.18,0,0,1,6.65,5.128L4.9,3.381.291,7.993a.992.992,0,0,0,0,1.4l6.727,6.726a.992.992,0,0,0,1.4,0l6.7-6.7a.993.993,0,0,0,0-1.4",
    transform: "translate(0 -0.072)",
    fill: "#de4c36"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.4dbbdf91dd89b5030a5444900b300fd4.svg";
export { ForwardRef as ReactComponent };